import { ReactElement } from 'react';

import { GridTableRowVariant } from '../../../shared/components/table-components';
import { ValueOfKey } from '../../../utils-types';
import { SCORING_RULE, ScoringRuleType } from '../../constants/scoringRule';
import { LeaderboardRowMobileVariant } from './components/LeaderboardRow/LeaderboardRowMobile/LeaderboardRowMobileWrapper/LeaderboardRowMobileWrapper';
import { EmptyListWrapperVariant } from './components/EmptyListWrapper/EmptyListWrapper';

export const LEADERBOARD_COLUMN = {
  RANK: 'RANK',
  INITIAL_SCAN_INDICATOR: 'INITIAL_SCAN_INDICATOR',
  CUSTOMER: 'CUSTOMER',
  TOTAL_SCORE: 'TOTAL_SCORE',
  FOOD_TRACKING_PERCENT: 'FOOD_TRACKING_PERCENT',
  FOOD_TRACKING_RANK: 'FOOD_TRACKING_RANK',
  FAT_LOSS_PERCENT: 'FAT_LOSS_PERCENT',
  ADJUSTED_FAT_LOSS_PERCENT: 'ADJUSTED_FAT_LOSS_PERCENT',
  FAT_LOSS_RANK: 'FAT_LOSS_RANK',
  FAT_LOSS_LBS: 'FAT_LOSS_LBS',
  MUSCLE_GAIN_LBS: 'MUSCLE_GAIN_LBS',
  MUSCLE_MULTIPLIER: 'MUSCLE_MULTIPLIER',
  ADJUSTED_SCORE_PERCENT: 'ADJUSTED_SCORE_PERCENT',
} as const;

export type LeaderboardColumn = ValueOfKey<typeof LEADERBOARD_COLUMN>;

export type RenderColumnInfo = Record<LeaderboardColumn, ReactElement | null>;

export const COLUMN_WIDTHS: Record<LeaderboardColumn, string> = {
  RANK: 'auto',
  INITIAL_SCAN_INDICATOR: 'auto',
  CUSTOMER: '1.25fr',
  TOTAL_SCORE: 'minmax(120px, 1fr)',
  FOOD_TRACKING_PERCENT: 'minmax(120px, 1fr)',
  FOOD_TRACKING_RANK: 'minmax(120px, 1fr)',
  FAT_LOSS_PERCENT: 'minmax(120px, 1fr)',
  ADJUSTED_FAT_LOSS_PERCENT: 'minmax(160px, 1fr)',
  FAT_LOSS_RANK: 'minmax(120px, 1fr)',
  FAT_LOSS_LBS: 'minmax(120px, 1fr)',
  MUSCLE_GAIN_LBS: 'minmax(120px, 1fr)',
  MUSCLE_MULTIPLIER: 'minmax(120px, 1fr)',
  ADJUSTED_SCORE_PERCENT: 'minmax(120px, 1fr)',
};

export const columnsConfig: Record<ScoringRuleType, LeaderboardColumn[]> = {
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING]: [
    LEADERBOARD_COLUMN.RANK,
    LEADERBOARD_COLUMN.INITIAL_SCAN_INDICATOR,
    LEADERBOARD_COLUMN.CUSTOMER,
    LEADERBOARD_COLUMN.TOTAL_SCORE,
    LEADERBOARD_COLUMN.FOOD_TRACKING_PERCENT,
    LEADERBOARD_COLUMN.FOOD_TRACKING_RANK,
    LEADERBOARD_COLUMN.FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.ADJUSTED_FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.FAT_LOSS_RANK,
    LEADERBOARD_COLUMN.MUSCLE_GAIN_LBS,
  ],
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN]: [
    LEADERBOARD_COLUMN.RANK,
    LEADERBOARD_COLUMN.INITIAL_SCAN_INDICATOR,
    LEADERBOARD_COLUMN.CUSTOMER,
    LEADERBOARD_COLUMN.ADJUSTED_SCORE_PERCENT,
    LEADERBOARD_COLUMN.FAT_LOSS_LBS,
    LEADERBOARD_COLUMN.FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.MUSCLE_GAIN_LBS,
    LEADERBOARD_COLUMN.MUSCLE_MULTIPLIER,
  ],
  [SCORING_RULE.FAT_LOSS]: [
    LEADERBOARD_COLUMN.RANK,
    LEADERBOARD_COLUMN.INITIAL_SCAN_INDICATOR,
    LEADERBOARD_COLUMN.CUSTOMER,
    LEADERBOARD_COLUMN.FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.FAT_LOSS_LBS,
    LEADERBOARD_COLUMN.MUSCLE_GAIN_LBS,
  ],
};

export type ChallengeLeaderboardVariant = 'outBox' | 'inBox';

type VariantConfig = {
  scrollContainer: 'outBox' | 'inBox';
  pagination: 'outBox' | 'inBox';
  tableRow: GridTableRowVariant;
  mobileRow: LeaderboardRowMobileVariant;
  emptyList: EmptyListWrapperVariant;
};

export const CHALLENGE_LEADERBOARD_VARIANT_CONFIG: Record<
  ChallengeLeaderboardVariant,
  VariantConfig
> = {
  outBox: {
    scrollContainer: 'outBox',
    pagination: 'outBox',
    tableRow: 'header',
    mobileRow: 'surface',
    emptyList: 'paper',
  },
  inBox: {
    scrollContainer: 'inBox',
    pagination: 'inBox',
    tableRow: 'unstyled',
    mobileRow: 'unstyled',
    emptyList: 'plain',
  },
};
